export default __webpack_public_path__ + "static/media/include_4@3x.342bc17c.jpg";